module.exports = __webpack_public_path__ + "static/media/1001568DO.3fcd5bce.jpg";